module.exports = __webpack_public_path__ + "static/media/13.ece747df.jpg";